export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";